import { useEffect, useState } from "react";

/**
 * "Вечерний режим" of the desktop website. The visitor's choice is remembered;
 * without a choice it follows the computer's dark/light setting.
 * The Mini App in Telegram never uses it.
 */
const KEY = "kms.night";
const EVENT = "kms:night";

function saved(): boolean | null {
  try {
    const v = localStorage.getItem(KEY);
    return v === "1" ? true : v === "0" ? false : null;
  } catch {
    return null;
  }
}

function systemDark(): boolean {
  return typeof window !== "undefined" && window.matchMedia?.("(prefers-color-scheme: dark)").matches === true;
}

export function useNight(): [boolean, () => void] {
  const [night, setNight] = useState<boolean>(() => saved() ?? systemDark());
  useEffect(() => {
    const sync = () => setNight(saved() ?? systemDark());
    window.addEventListener(EVENT, sync);
    const mq = window.matchMedia?.("(prefers-color-scheme: dark)");
    mq?.addEventListener?.("change", sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      mq?.removeEventListener?.("change", sync);
    };
  }, []);
  const toggle = () => {
    try {
      localStorage.setItem(KEY, night ? "0" : "1");
    } catch {
      /* storage unavailable — still switch for this visit */
    }
    const root = document.documentElement;
    root.classList.add("dk-theme-anim");
    window.setTimeout(() => root.classList.remove("dk-theme-anim"), 600);
    setNight(!night);
    window.dispatchEvent(new Event(EVENT));
  };
  return [night, toggle];
}
